var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConfirmation = function SvgConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 18.5C7.8 21 4 17.2 4 12.5S7.8 4 12.5 4 21 7.8 21 12.5 17.2 21 12.5 21zm4.6-11.7c.3.3.3.8 0 1.1l-5.5 5.3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L8 13.1c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.1 2.1L16 9.3c.3-.3.8-.3 1.1 0z"
  })));
};
export default SvgConfirmation;